import { authConfig } from '@bg-shared/business/Auth/Auth.config';
import { routeUrlGenerator } from '@bg-shared/utils/routeUrlGenerator';
import { AuthType } from '@bg-shared/business/Auth/enums';

export const refreshIframe = (): void => {
    const route =
        authConfig.authType === AuthType.DEFAULT
            ? routeUrlGenerator.routes.AUTH
            : routeUrlGenerator.routes.INTEGRATION;

    window.history.replaceState({}, '', `/${route}${authConfig.authQuery}`);
    window.location.reload();
};
